<template>
  <div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="FooterImgLogo"
      viewBox="0 0 22.773 28.57"
    >
      <g id="LogoCsaMedDarkMode" transform="translate(-140 -221)">
        <g id="Loader" transform="translate(146.315 221)">
          <circle
            id="Ellisse_Top_Center"
            data-name="Ellisse 19"
            cx="1.346"
            cy="1.346"
            r="1.346"
            transform="translate(4.141 0)"
            :fill="`#${darkMode ? 'e2e2e2' : '1a3b51'}`"
          />
          <circle
            id="Ellisse_20"
            data-name="Ellisse 20"
            cx="1.242"
            cy="1.242"
            r="1.242"
            transform="translate(1.242 1.449)"
            :fill="`#${darkMode ? 'e2e2e2' : '375c79'}`"
          />
          <circle
            id="Ellisse_21"
            data-name="Ellisse 21"
            cx="1.139"
            cy="1.139"
            r="1.139"
            transform="translate(0 4.555)"
            :fill="`#${darkMode ? 'e2e2e2' : '00547c'}`"
          />
          <circle
            id="Ellisse_22"
            data-name="Ellisse 22"
            cx="0.983"
            cy="0.983"
            r="0.983"
            transform="translate(1.449 7.764)"
            :fill="`#${darkMode ? 'e2e2e2' : '0076b1'}`"
          />
          <circle
            id="Ellisse_23"
            data-name="Ellisse 23"
            cx="0.932"
            cy="0.932"
            r="0.932"
            transform="translate(4.555 9.109)"
            :fill="`#${darkMode ? 'e2e2e2' : '4caacf'}`"
          />
          <circle
            id="Ellisse_24"
            data-name="Ellisse 24"
            cx="0.776"
            cy="0.776"
            r="0.776"
            transform="translate(7.764 7.971)"
            :fill="`#${darkMode ? 'e2e2e2' : '4ab4da'}`"
          />
          <circle
            id="Ellisse_25"
            data-name="Ellisse 25"
            cx="0.621"
            cy="0.621"
            r="0.621"
            transform="translate(9.213 5.072)"
            :fill="`#${darkMode ? 'e2e2e2' : 'ddf0fa'}`"
          />
          <circle
            id="Ellisse_26"
            data-name="Ellisse 26"
            cx="0.569"
            cy="0.569"
            r="0.569"
            transform="translate(7.971 2.174)"
            :fill="`#${darkMode ? 'e2e2e2' : '2b3342'}`"
          />
        </g>
        <path
          id="MED"
          d="M12.153,17.469A2.952,2.952,0,1,1,16.248,14.6H11.081c0,.05-.005.1-.005.155a2.226,2.226,0,0,0,4.311.776h.761a2.953,2.953,0,0,1-4,1.942Zm-.937-3.495h4.172a2.226,2.226,0,0,0-4.172,0ZM8.9,17.7v-3.83h.621V17.7Zm-4.089,0v-3.83h.621V17.7Zm-4.089,0v-3.83a2.017,2.017,0,0,1,.708-1.466,2.482,2.482,0,0,1,1.646-.6,2.482,2.482,0,0,1,1.646.6,2.177,2.177,0,0,1,.4.463,2.176,2.176,0,0,1,.4-.463,2.543,2.543,0,0,1,3.292,0,2.018,2.018,0,0,1,.708,1.466H8.9A1.655,1.655,0,0,0,7.168,12.36a1.654,1.654,0,0,0-1.733,1.511H4.812A1.654,1.654,0,0,0,3.079,12.36a1.654,1.654,0,0,0-1.733,1.511h0V17.7Zm17.95-.232a2.951,2.951,0,1,1,3.234-4.8q.073.073.139.149V6.832h.725V14.8h0a2.952,2.952,0,0,1-4.1,2.667ZM17.6,14.751a2.226,2.226,0,1,0,2.225-2.226A2.228,2.228,0,0,0,17.6,14.751Zm5.175-7.919h-.724a3.524,3.524,0,0,0-3.52-3.52H1.81a.932.932,0,1,1-.044-.725h9.827V0h.414V2.588h6.522a4.24,4.24,0,0,1,4.244,4.244h0Z"
          transform="translate(140 231.869)"
          :fill="`#${darkMode ? 'e2e2e2' : '4caacf'}`"
        />
        <path
          id="CSA"
          d="M13.824,6.265a3.305,3.305,0,0,1-1.053-.7,3.248,3.248,0,0,1-.71-1.036,3.225,3.225,0,0,1,0-2.538,3.247,3.247,0,0,1,.71-1.036,3.3,3.3,0,0,1,1.053-.7,3.357,3.357,0,0,1,3.614.682,3.249,3.249,0,0,1,.713,1.02,3.2,3.2,0,0,1,.275,1.251h0V6.418H17.7V5.3a3.354,3.354,0,0,1-3.877.969Zm-1.2-3.056a2.537,2.537,0,1,0,5.072,0,2.537,2.537,0,1,0-5.072,0ZM7.749,5.976a1.763,1.763,0,0,1-.606-1.318,1.712,1.712,0,0,1,.013-.207h.826a1.165,1.165,0,0,0-.01.155,1.243,1.243,0,0,0,2.484,0,1.219,1.219,0,0,0-1.242-1.19h0a1.857,1.857,0,0,1-1.229-.5A1.64,1.64,0,0,1,7.984.5a1.89,1.89,0,0,1,2.562,0,1.656,1.656,0,0,1,.53,1.156h-.729a1.091,1.091,0,0,0-2.168.1A1.057,1.057,0,0,0,9.213,2.794h0a2.179,2.179,0,0,1,1.464.546,1.734,1.734,0,0,1,0,2.635,2.237,2.237,0,0,1-2.928,0Zm-5.757.289A3.261,3.261,0,1,1,6.265,1.991l.019.046H5.4A2.492,2.492,0,0,0,3.21.713a2.525,2.525,0,0,0-2.5,2.547,2.525,2.525,0,0,0,2.5,2.547A2.5,2.5,0,0,0,5.634,3.872h.831A3.264,3.264,0,0,1,1.991,6.265Z"
          transform="translate(141.76 236.32)"
          :fill="`#${darkMode ? 'e2e2e2' : '1a3b51'}`"
        />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    darkMode: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped></style>
